import React from 'react'
import { Heading } from 'selfServicePortal/components'
import { useTranslation } from 'react-i18next'
import { Message } from 'selfServicePortal/components/Message/Message'

interface SuccessProps {
	onSuccess: () => void
}

export function Success({ onSuccess }: SuccessProps) {
	const { t } = useTranslation()

	return (
		<>
			<Heading title={t('MyAccountSuccessTitle')} />

			<div className="success-container">
				<Message
					type="success"
					message={t('MyAccountSuccessMessage')}
				/>
			</div>

			<div>
				<button
					type="button"
					className="btn btn-primary"
					onClick={onSuccess}>
					{t('Back')}
				</button>
			</div>
		</>
	)
}
